import { connect } from "react-redux";
import get from "lodash/get";

import { getAnaliseSignal as onGetAnaliseSignal } from "../../actions/analiseSignalActions";

const mapStateToProps = (state) => ({
  analiseSignalDataState: state.analiseSignals.analiseSignalDataState,
  analiseSignals: get(state, ["analiseSignals", "analiseSignals"], { connections: [] }),
});

const mapDispatchToProps = { onGetAnaliseSignal };

const withAnaliseSignal = (Component) => connect(mapStateToProps, mapDispatchToProps)(Component);

export { withAnaliseSignal };
